import React, { useState, useEffect, useContext } from 'react';
import InputLogin from '../../inputs/InputLogin'
import Switch from '../../switch/Switch'
import TextArea from '../../textArea/TextArea'
import UploadPDF from '../../inputs/UploadPDF'
import SearchableSelect from '../../select/SearchableSelect'
import SelectPhone from '../../select/selectPhone'
import ButtonNext from '../../button/ButtonWhite'
import InputDate from '../../inputs/inputDate'

import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";

import { formatPhoneNumber } from '../../../utils/FormatPhoneNumber';
import { ReactComponent as NEXT } from '../../../assets/IconsColurs/IconsGeneral/chevronRight.svg'

const Step1 = ({
    LoadingLayouts,
    ListaState,
    ListCountry,
    listCities,
    setEnterPriseLegaName,
    setIsCompanyPrivate,
    enterpriseIdentification,
    setEnterpriseIdentification,
    setCreationDate,
    setCountryRegistered,
    setCountryState,
    setAddress,
    setCity,
    setPhoneNumber,
    setPhoneNumberCode,
    phoneNumberCode,
    setWebsite,
    setEnterpriseDescription,
    setDocuments_step_1,
    enterpriseLegaName,
    isCompanyPrivate,
    creationDate,
    countryRegistered,
    countryState,
    city,
    address,
    phoneNumber,
    website,
    enterpriseDescription,
    documents_step_1,
    setArhivoSociedad,
    setArhivoTributario,
    setArhivoMercantil,
    setArhivoBrochure,
    ArhivoSociedad,
    ArhivoTributario,
    ArhivoMercantil,
    ArhivoBrochure,
    onClick,
    loading,

    /* manejo de errores */
    errorMesagge = "",
    enterpriseLegaNameError,
    enterpriseLegaNameReadOnly,
    isCompanyPrivateError,
    isCompanyPrivateReadOnly,
    enterpriseIdentificationError,
    enterpriseIdentificationReadOnly,
    creationDateError,
    countryRegisteredError,
    countryRegisteredReadOnly,
    websiteError,
    websiteReadOnly,
    cityError,
    cityReadOnly,
    countryStateError,
    countryStateReadOnly,
    phoneNumberError,
    phoneNumberReadOnly,
    phoneNumberCodeError,
    phoneNumberCodeReadOnly,
    addressError,
    addressReadOnly,
    enterpriseDescriptionError,
    enterpriseDescriptionReadOnly,
    ArhivoSociedadError,
    ArhivoSociedadReadOnly,
    ArhivoTributarioError,
    ArhivoTributarioReadOnly,
    ArhivoMercantilError,
    ArhivoMercantilReadOnly,
    ArhivoBrochureError,
    ArhivoBrochureReadOnly,
    documents_step_1Error,
    documents_step_1ReadOnly,
    error

}) => {


    const [formattedPhone, setFormattedPhone] = useState(phoneNumber);
    const [isReady, setIsReady] = useState(false);

    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    console.log("language", language);

    const handlePhoneChange = (value) => {
        const formatted = formatPhoneNumber(value);

        // Validación específica para Colombia (+57) - debe tener exactamente 10 dígitos
        if (phoneNumberCode === '+57') {
            const numericValue = formatted.replace(/\D/g, "");
            if (numericValue.length > 10) {
                // Si excede 10 dígitos, truncar a 10 dígitos
                const truncatedValue = numericValue.substring(0, 10);
                const truncatedFormatted = formatPhoneNumber(truncatedValue);
                setPhoneNumber(truncatedFormatted);
                return;
            }
        }

        // Permitir escribir mientras se está digitando
        setPhoneNumber(formatted);
    };
    useEffect(() => {
        if (phoneNumber) {
            handlePhoneChange(phoneNumber)
        }
    }, [phoneNumber])
    useEffect(() => {
        if (
            !LoadingLayouts

        ) {
            setIsReady(true)
        }
    }, [
        LoadingLayouts
    ]);

    if (!isReady) {
        return <div className="flex md:flex-row flex-wrap p-4 w-full" >
            <div className="w-full" >
                <div style={{ height: "50vh", }} className='flex items-center justify-center'>
                    <div className="h-20  w-20 flex">
                        <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

                    </div>
                </div>
            </div>
        </div>

    }
    return (
        <div className="w-full h-fit pb-16 gap-4 flex flex-col"  >
            <p className="text-2xl mt-8 mb-4" style={{ fontFamily: "brico" }}>{GLOBAL_LANGUAGE[language].steps1.title}</p>
            <div className="space-y-4">
                <div>
                    <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.label_name_legal_company}</p>
                    <InputLogin value={enterpriseLegaName} onChange={(e) => setEnterPriseLegaName(e)} error={enterpriseLegaNameError} placeholder={GLOBAL_LANGUAGE[language].steps1.name_legal_company_placeholder} />
                </div>

                <div className='flex flex-row items-center gap-4'>
                    <Switch value={isCompanyPrivate} setValue={setIsCompanyPrivate} />
                    <p>{GLOBAL_LANGUAGE[language].steps1.sector_company}</p>
                </div>

                <div className='flex flex-col md:flex-row gap-4'>
                    <div className='w-full md:w-1/2'>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.identification_company}</p>
                        <InputLogin onChange={(e) => setEnterpriseIdentification(e)} value={(enterpriseIdentification)} error={enterpriseIdentificationError} placeholder={GLOBAL_LANGUAGE[language].steps1.identification_company_placeholder} />
                    </div>
                    <div className='w-full md:w-1/2'>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.company_create_date}</p>
                        <InputDate setDate={setCreationDate} label={'Seleccione día, mes y año'} error={creationDateError} value={creationDate} />
                    </div>
                </div>

                <div className='flex flex-col md:flex-row gap-4'>
                    <div className='w-full md:w-1/2'>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.label_state}</p>
                        <SearchableSelect setSelectOpcion={setCountryState} list={ListaState} error={countryStateError} label={countryState} />
                    </div>
                    <div className='w-full md:w-1/2'>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.label_city}</p>
                        <SearchableSelect setSelectOpcion={setCity} list={listCities} error={cityError} label={city} />
                    </div>
                </div>

                <div className='flex flex-col md:flex-row gap-4'>
                    <div className='w-full md:w-1/2'>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.address}</p>
                        <InputLogin onChange={(e) => setAddress(e)} value={address} error={addressError} placeholder={GLOBAL_LANGUAGE[language].steps1.address_placeholder} />
                    </div>
                    <div className='w-full md:w-1/2'>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.phone_number}</p>
                        <div className='flex gap-2'>
                            <SelectPhone setValue={setPhoneNumberCode} value={phoneNumberCode} error={phoneNumberError} />
                            <InputLogin onChange={handlePhoneChange} value={phoneNumber} placeholder={GLOBAL_LANGUAGE[language].steps1.phone_number_placeholder} error={phoneNumberError} className="flex-1" />
                        </div>
                    </div>
                </div>

                <div>
                    <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.label_website}</p>
                    <InputLogin onChange={(e) => setWebsite(e)} value={website} placeholder={GLOBAL_LANGUAGE[language].steps1.website_placeholder} error={websiteError} />
                </div>

                <div>
                    <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps1.company_description}</p>
                    <TextArea onChange={(e) => setEnterpriseDescription(e)} value={enterpriseDescription} error={enterpriseDescriptionError} placeholder={GLOBAL_LANGUAGE[language].steps1.company_description_placeholder} />
                </div>

                <div className="space-y-4">
                    <div>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].documents.arhivo_sociedad}</p>
                        <UploadPDF setUploadedFile={setArhivoSociedad} uploadedFile={ArhivoSociedad} error={ArhivoSociedadError} />
                    </div>
                    <div>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].documents.arhivo_tributario}</p>
                        <UploadPDF setUploadedFile={setArhivoTributario} uploadedFile={ArhivoTributario} error={ArhivoTributarioError} />
                    </div>
                    <div>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].documents.arhivo_mercantil}</p>
                        <UploadPDF setUploadedFile={setArhivoMercantil} uploadedFile={ArhivoMercantil} error={ArhivoMercantilError} />
                    </div>
                    <div>
                        <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].documents.arhivo_brochure}</p>
                        <UploadPDF setUploadedFile={setArhivoBrochure} uploadedFile={ArhivoBrochure} error={ArhivoBrochureError} />
                    </div>
                </div>

                {error && (
                    <div className="w-full">
                        <p className="text-[#FF928B] text-[16px]">
                            {errorMesagge}
                        </p>
                    </div>
                )}

                <div className='flex justify-end w-full mt-4' >
                    <ButtonNext label={GLOBAL_LANGUAGE[language].steps1.label_button} Icon={NEXT} onClick={onClick} loading={loading} />
                </div>
            </div>
        </div>

    );
};

export default Step1;

